module.exports = {
      id: "0bf975d6180afb777e16b4f5493bf639roofShape-mono-pitched.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#0bf975d6180afb777e16b4f5493bf639roofShape-mono-pitched.svg",
      toString: function () {
        return this.url;
      }
    }